import {Button, EmptyStatus} from 'platform/components';
import {HStack, Show, Space, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {usePermissions} from '@dms/shared';

import {TestIdProps} from 'shared/web';

import {useUpdateInspectionStructure} from '../hooks/useUpdateInspectionStructure';

const EMPTY_STATE_HEADLINE_TRANSLATION_KEY =
  'entity.inspection.labels.vehicleConditionEmptyStateHeadline';
const EMPTY_STATE_SUBHEADLINE_TRANSLATION_KEY =
  'entity.inspection.labels.vehicleConditionEmptyStateSubheadline';
const EMPTY_STATE_WITHOUT_SETTINGS_SUBHEADLINE_TRANSLATION_KEY =
  'entity.inspection.labels.vehicleConditionEmptyStateWithoutSettingsSubheadline';

export interface VehicleConditionEmptyStateProps extends TestIdProps {
  inspectionId: string;
}

export function VehicleConditionEmptyState(props: VehicleConditionEmptyStateProps) {
  const [hasReadSettingsPermission] = usePermissions({permissionKeys: ['readSettings']});
  const {isLoading, updateInspectionStructure} = useUpdateInspectionStructure(props.inspectionId);

  return (
    <VStack align="center" spacing={3} data-testid={props['data-testid']}>
      <EmptyStatus
        headline={i18n.t(EMPTY_STATE_HEADLINE_TRANSLATION_KEY)}
        subheadline={
          hasReadSettingsPermission
            ? i18n.t(EMPTY_STATE_SUBHEADLINE_TRANSLATION_KEY)
            : i18n.t(EMPTY_STATE_WITHOUT_SETTINGS_SUBHEADLINE_TRANSLATION_KEY)
        }
        variant="vehicle"
        data-testid="vehicle-condition-empty-state"
      />
      <Space vertical={1} />
      <HStack align="center" justify="center" spacing={2} wrap>
        <Button
          title={i18n.t('entity.inspection.labels.updateTechnicalConditionStructure')}
          onClick={updateInspectionStructure}
          isLoading={isLoading}
        />
        <Show when={hasReadSettingsPermission}>
          <Button
            title={i18n.t('general.labels.goToSettings')}
            to={settingsRoutes.vehicleCondition}
            variant="secondary"
          />
        </Show>
      </HStack>
    </VStack>
  );
}
